// @flow
import { createSelector } from "reselect"
import * as R from "ramda"

import { brandingSelector, supportEmailSelector, supportPhoneSelector } from "../branding/selectors"
import pureTranslate from "./pureTranslate"

// $FlowFixMe
const optionsSelector = state => state.options

// $FlowFixMe
const translationsSelector = state => state.translations

export const brandingTranslationPlaceholdersSelector: $FlowFixMe = createSelector(
  [brandingSelector, supportEmailSelector, supportPhoneSelector],
  (branding, supportEmail, supportPhone) => ({
    brandName: branding.get("name"),
    brandDomain: branding.get("domain"),
    companyName: branding.get("company_name"),
    legalName: "Kiwi.com",
    legalDomain: "https://kiwi.com",
    oldBrand: "Skypicker",
    supportEmail,
    supportPhone,
  }),
)

// $FlowFixMe
export default createSelector(
  [translationsSelector, optionsSelector, brandingTranslationPlaceholdersSelector],
  (translations, appOptions, brandingTranslationPlaceholders) => {
    if (appOptions.showTranslationKeys) {
      return id => id
    }

    return function translate(
      key: string,
      vals: ?Object, // eslint-disable-line flowtype/no-weak-types
      originalOptions: ?Object = {}, // eslint-disable-line flowtype/no-weak-types
      omittedValues: ?(string[]) = [],
    ) {
      const options = {
        language: appOptions.get("language"),
        translations,
        ...originalOptions,
      }

      let values = { ...brandingTranslationPlaceholders, ...vals }

      values = R.omit(omittedValues, values)

      return pureTranslate(key, values, options)
    }
  },
)
